<template>
 <div class="ui centered grid">
    <div class="three wide column"></div>
    <div class="ten wide column">
        <div class="ten wide column">
            <div v-if="!loading">
                  <div  class="ui active bottom attached tab segment">
                    <TheListView v-bind:itemList="itemList" v-bind:highlight="highlight"></TheListView>
                </div>
            </div>
        </div>
    </div>
    <div class="three wide column"></div>
    <div class="sixteen wide column ">
        <div class="ui center aligned container">
            <div v-if="!loading">
              <div class="ui pagination menu">
                  <a v-for="page in (endPage - startPage+1)" :key="page+startPage-1" v-on:click="goToPage(page+startPage-1)" v-bind:class="{'item':true, 'active':((page+startPage-1) === currentPage)}">{{page+startPage-1}}</a>
              </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  import TheListView from '../components/TheListView.vue'
  export default {
    name: 'list',
    components: {
      TheListView
    },
    data() {
      return {
        inventory: "1615_Brussels",
        itemList: null,
        itemsPerPage: 20,
        startPage: 0,
        endPage: 0,
        currentPage: 1,
        cursor: 0,
        loading: true,
        highlight:""
      }
    },


    methods: {
      goToPage: function(page) {
        this.$router.push({ name: 'list', query: { inventory: this.inventory, page: page } })
      },
      
      serializefromJSON: function(query) {
        var output = "";
        for (var key in query) {
          if (Array.isArray(query[key])) {
            for (var i in query[key]) {
              output += key + "=" + encodeURIComponent(query[key][i]) + "&";
            }
          }
          else {
            output += key + "=" + encodeURIComponent(query[key]) + "&";
          }
        }
        return output.slice(0, -1);
      },

      loadData: function(loading) {
        this.loading = loading;
        
        if (this.$route.query.hasOwnProperty('highlight')) {
          this.highlight=this.$route.query.highlight;
        }
        if (this.$route.query.hasOwnProperty('page')) {
          this.currentPage = parseInt(this.$route.query.page);
          this.cursor = this.itemsPerPage * (this.currentPage - 1);
        }

        if (this.$route.query.hasOwnProperty('inventory')) {
          this.inventory = this.$route.query.inventory;
        }
        var query={
          inventory:this.inventory,
          cursor:this.cursor,
          items:this.itemsPerPage
        }

        axios
      //    .get('/api/search?cursor=' + this.cursor + '&items=' + this.itemsPerPage + '&search_query=inventory:\'' + this.inventory + '\'')
          .get('/api/search_v2?' + this.serializefromJSON(query))
          .then(response => {
            this.itemList = response.data.data;
            var noOfPages = Math.ceil(response.data.pagination.records / this.itemsPerPage);

            if (noOfPages <= 10) {
              this.startPage = 1;
              this.endPage = noOfPages;
            }
            else if ((noOfPages - this.currentPage) < 10) {
              this.startPage = noOfPages - 10;
              this.endPage = noOfPages;
            }
            else if (this.currentPage > 5) {
              this.startPage = this.currentPage - 4;
              this.endPage = this.currentPage + 5;
            }
            else {
              this.startPage = 1;
              this.endPage = 10;
            }
            this.loading = false;

          });
      },


    },

    mounted() {
      this.loadData(true);
     // console.log("Refferer: "+document.referrer);
    },

    watch: {
      $route(to, from) {
        this.loadData();
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/list.vue